import React from 'react'

const Task = ({ changeCheckedTasks, disabled = false, checked = false, task = {} }) => {
    return (
        <div className="justify-between items-center">
            <div className="flex justify-start items-center">
                <input
                    disabled={disabled}
                    className="mr-1"
                    type="checkbox"
                    onChange={(e) => {changeCheckedTasks(task)}}
                    checked={checked}
                />
                <div className="text-sm">
                    <div className={`${disabled ? 'line-through' : ''}`}>
                    { task.retakereason > 0 ? 'Retake:' + task.type.name  : task.type.name }
                    </div>
                    {  task.supplier &&
                        <div className={`${disabled ? 'line-through' : ''}`}>
                            { typeof task.supplier === 'object' ? task.supplier.userid : task.supplier }
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}

export default Task;